import React from 'react';
import PropTypes from 'prop-types';

import InfoMessage from 'chameleon/ui-stack/ui/basic/info-message';
import FrqPPC from './FrqPPC';
import McqPPC from './McqPPC';
import FrqPE from './FrqPE';
import ShareContent from './ShareContent';
import PreAPPerformance from './PreAPPerformance';

const getPopoverContent = (disablePpcAutoAssignFlag = false) => ({
  MCQ_1: McqPPC,
  FRQ_1: disablePpcAutoAssignFlag ? FrqPE : FrqPPC,
  PreAP_Quiz_1: PreAPPerformance,
  PreAP_Quiz_2: FrqPPC, // use the same fake progress popover as AP
  FRQ_PE: FrqPE,
});

export const PopoverContent = ({
  ppcType,
  adminMessage,
  popoverHeader,
  disablePpcAutoAssignFlag,
}) => {
  const Content = getPopoverContent(disablePpcAutoAssignFlag)[ppcType];
  return (
    <div className="progress-popover">
      <div className="flex flex-row justify-between border-b border-gray-300">
        <div className="text-2xl font-bold text-black text-left px-4.6 py-4.2">
          {popoverHeader}
        </div>
      </div>
      <InfoMessage>{adminMessage}</InfoMessage>
      <div className="py-4.2">
        <Content />
      </div>
    </div>
  );
};

PopoverContent.propTypes = {
  popoverHeader: PropTypes.string,
  ppcType: PropTypes.string,
  adminMessage: PropTypes.string,
  disablePpcAutoAssignFlag: PropTypes.bool,
};

PopoverContent.defaultProps = {
  popoverHeader: 'Progress Check (All Progress)',
  closePopover: () => {},
  adminMessage: '',
  ppcType: '',
  disablePpcAutoAssignFlag: false,
};
export { ShareContent };
export default getPopoverContent;
